import CdnIconProxy from '~/apps/account-linking/components/CdnIconProxy';
import { FixedColumn } from '../FixedColumn';
import { P2GBox, SvgCaretDown } from '@parcel2go/core-ui';

interface props {
  m?: number;
  mt?: number;
  mb?: number;
  ml?: number;
  mr?: number;
  p?: number;
  pt?: number;
  pb?: number;
  pl?: number;
  pr?: number;
  children: React.ReactNode;
}

const Expansion: React.FC<props> = (props) => {
  return (
    <P2GBox {...props}>
      <FixedColumn
        left={
          <CdnIconProxy palette="primary" src="/theme/icons/CaretDown.svg">
            <SvgCaretDown />
          </CdnIconProxy>
        }
        right={props.children}
        width={30}
      />
    </P2GBox>
  );
};

export { Expansion };
